module.exports = __webpack_public_path__ + "media/nyul_k.0ccd03af.mp3";